export const COMMA_WITH_SINGLE_DIGIT = '0,0.0';
export const COMMA_WITH_DOUBLE_DIGITS = '0,0.00';
export const COMMA = '0,0';
